import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  searchBar: '',
  pageSize: 10,
}

const tableSlice = createSlice({
  name: 'table',
  initialState,
  reducers: {
    setSearchBar: (state, action) => {
      state.searchBar = action.payload
    },
    setSlicePageSize: (state, action) => {
      state.pageSize = action.payload
    },
  },
})

export default tableSlice.reducer
export const { setSearchBar, setSlicePageSize } = tableSlice.actions
